// Based on and named after Shaun Inman’s ancient wordpress plugin that eliminates widows (a single word on a line at the end of a paragraph).
// https://shauninman.com/archive/2006/08/22/widont_wordpress_plugin

const widont = string => {
  return string.replace(/([^\s])\s+([^\s]+)\s*$/, '$1\u00A0$2')
}

export default widont
